import styled from '@emotion/styled'

// Library
import Container from 'library/Container'

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    flex-direction: row;
    align-content: center;
  }
`
const Items = styled.div`
  margin-top: 2.75rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    margin-top: 8.2vw;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
    margin-top: 6.5rem;
  }
`

const FlexContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  padding: 1rem 1rem 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    align-items: center;

    padding: 1rem 1.777rem 1.5rem;
  }
`

const Title = styled.h1`
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryLightest};

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    width: 100%;
    max-width: 800px;

    font-size: 10.4vw;
    text-align: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
    font-size: 8.666666666666667rem;
  }
`

const Text = styled.div`
  line-height: 22px;
  letter-spacing: 0.82px;

  > p {
    margin-bottom: 1rem;

    letter-spacing: 0.73px;
    color: ${({ theme }) => theme.colors.primaryDarkest};

    &:last-of-type {
      margin-bottom: 0;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
      letter-spacing: 0.82px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    width: 100%;
    max-width: 56%;
    margin-top: -4.722222222222222vw;

    font-size: 0.6666666666666667rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    font-size: 0.7777777777777778rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    font-size: 0.8888888888888889rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
    max-width: 800px;
    margin-top: -3.777777777777778rem;

    font-size: 1rem;
  }
`

export { Wrapper, Items, FlexContainer, Title, Text }
